/*eslint-disable block-scoped-var, id-length, no-control-regex, no-magic-numbers, no-prototype-builtins, no-redeclare, no-shadow, no-var, sort-vars*/
"use strict";

var $protobuf = require("protobufjs/minimal");

// Common aliases
var $Reader = $protobuf.Reader, $Writer = $protobuf.Writer, $util = $protobuf.util;

// Exported root namespace
var $root = $protobuf.roots["default"] || ($protobuf.roots["default"] = {});

$root.ussevent = (function() {

    /**
     * Namespace ussevent.
     * @exports ussevent
     * @namespace
     */
    var ussevent = {};

    /**
     * EventID enum.
     * @name ussevent.EventID
     * @enum {number}
     * @property {number} MMSInitUploadSDKEvent=30001 MMSInitUploadSDKEvent value
     * @property {number} MMSGetTokenEvent=30002 MMSGetTokenEvent value
     * @property {number} MMSPreUploadEvent=30003 MMSPreUploadEvent value
     * @property {number} MMSFileTransferEvent=30004 MMSFileTransferEvent value
     * @property {number} MMSReportUploadEvent=30005 MMSReportUploadEvent value
     * @property {number} MMSImgGetStrategyEvent=80001 MMSImgGetStrategyEvent value
     * @property {number} MMSImgCompressEvent=80002 MMSImgCompressEvent value
     * @property {number} MMSImgPreuploadEvent=80003 MMSImgPreuploadEvent value
     * @property {number} MMSImgFileTransferEvent=80004 MMSImgFileTransferEvent value
     * @property {number} MMSImgNotifyEvent=80005 MMSImgNotifyEvent value
     * @property {number} MMSGetEndpointStrategyEvent=80006 MMSGetEndpointStrategyEvent value
     */
    ussevent.EventID = (function() {
        var valuesById = {}, values = Object.create(valuesById);
        values[valuesById[30001] = "MMSInitUploadSDKEvent"] = 30001;
        values[valuesById[30002] = "MMSGetTokenEvent"] = 30002;
        values[valuesById[30003] = "MMSPreUploadEvent"] = 30003;
        values[valuesById[30004] = "MMSFileTransferEvent"] = 30004;
        values[valuesById[30005] = "MMSReportUploadEvent"] = 30005;
        values[valuesById[80001] = "MMSImgGetStrategyEvent"] = 80001;
        values[valuesById[80002] = "MMSImgCompressEvent"] = 80002;
        values[valuesById[80003] = "MMSImgPreuploadEvent"] = 80003;
        values[valuesById[80004] = "MMSImgFileTransferEvent"] = 80004;
        values[valuesById[80005] = "MMSImgNotifyEvent"] = 80005;
        values[valuesById[80006] = "MMSGetEndpointStrategyEvent"] = 80006;
        return values;
    })();

    ussevent.EventList = (function() {

        /**
         * Properties of an EventList.
         * @memberof ussevent
         * @interface IEventList
         * @property {Array.<ussevent.IEvent>|null} [events] EventList events
         */

        /**
         * Constructs a new EventList.
         * @memberof ussevent
         * @classdesc Represents an EventList.
         * @implements IEventList
         * @constructor
         * @param {ussevent.IEventList=} [properties] Properties to set
         */
        function EventList(properties) {
            this.events = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * EventList events.
         * @member {Array.<ussevent.IEvent>} events
         * @memberof ussevent.EventList
         * @instance
         */
        EventList.prototype.events = $util.emptyArray;

        /**
         * Creates a new EventList instance using the specified properties.
         * @function create
         * @memberof ussevent.EventList
         * @static
         * @param {ussevent.IEventList=} [properties] Properties to set
         * @returns {ussevent.EventList} EventList instance
         */
        EventList.create = function create(properties) {
            return new EventList(properties);
        };

        /**
         * Encodes the specified EventList message. Does not implicitly {@link ussevent.EventList.verify|verify} messages.
         * @function encode
         * @memberof ussevent.EventList
         * @static
         * @param {ussevent.IEventList} message EventList message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        EventList.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.events != null && message.events.length)
                for (var i = 0; i < message.events.length; ++i)
                    $root.ussevent.Event.encode(message.events[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified EventList message, length delimited. Does not implicitly {@link ussevent.EventList.verify|verify} messages.
         * @function encodeDelimited
         * @memberof ussevent.EventList
         * @static
         * @param {ussevent.IEventList} message EventList message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        EventList.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an EventList message from the specified reader or buffer.
         * @function decode
         * @memberof ussevent.EventList
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {ussevent.EventList} EventList
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        EventList.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.ussevent.EventList();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    if (!(message.events && message.events.length))
                        message.events = [];
                    message.events.push($root.ussevent.Event.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an EventList message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof ussevent.EventList
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {ussevent.EventList} EventList
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        EventList.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an EventList message.
         * @function verify
         * @memberof ussevent.EventList
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        EventList.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.events != null && message.hasOwnProperty("events")) {
                if (!Array.isArray(message.events))
                    return "events: array expected";
                for (var i = 0; i < message.events.length; ++i) {
                    var error = $root.ussevent.Event.verify(message.events[i]);
                    if (error)
                        return "events." + error;
                }
            }
            return null;
        };

        /**
         * Creates an EventList message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof ussevent.EventList
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {ussevent.EventList} EventList
         */
        EventList.fromObject = function fromObject(object) {
            if (object instanceof $root.ussevent.EventList)
                return object;
            var message = new $root.ussevent.EventList();
            if (object.events) {
                if (!Array.isArray(object.events))
                    throw TypeError(".ussevent.EventList.events: array expected");
                message.events = [];
                for (var i = 0; i < object.events.length; ++i) {
                    if (typeof object.events[i] !== "object")
                        throw TypeError(".ussevent.EventList.events: object expected");
                    message.events[i] = $root.ussevent.Event.fromObject(object.events[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from an EventList message. Also converts values to other types if specified.
         * @function toObject
         * @memberof ussevent.EventList
         * @static
         * @param {ussevent.EventList} message EventList
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        EventList.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.events = [];
            if (message.events && message.events.length) {
                object.events = [];
                for (var j = 0; j < message.events.length; ++j)
                    object.events[j] = $root.ussevent.Event.toObject(message.events[j], options);
            }
            return object;
        };

        /**
         * Converts this EventList to JSON.
         * @function toJSON
         * @memberof ussevent.EventList
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        EventList.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return EventList;
    })();

    ussevent.Event = (function() {

        /**
         * Properties of an Event.
         * @memberof ussevent
         * @interface IEvent
         * @property {ussevent.IHeader|null} [header] Event header
         * @property {Uint8Array|null} [body] Event body
         */

        /**
         * Constructs a new Event.
         * @memberof ussevent
         * @classdesc Represents an Event.
         * @implements IEvent
         * @constructor
         * @param {ussevent.IEvent=} [properties] Properties to set
         */
        function Event(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Event header.
         * @member {ussevent.IHeader|null|undefined} header
         * @memberof ussevent.Event
         * @instance
         */
        Event.prototype.header = null;

        /**
         * Event body.
         * @member {Uint8Array} body
         * @memberof ussevent.Event
         * @instance
         */
        Event.prototype.body = $util.newBuffer([]);

        /**
         * Creates a new Event instance using the specified properties.
         * @function create
         * @memberof ussevent.Event
         * @static
         * @param {ussevent.IEvent=} [properties] Properties to set
         * @returns {ussevent.Event} Event instance
         */
        Event.create = function create(properties) {
            return new Event(properties);
        };

        /**
         * Encodes the specified Event message. Does not implicitly {@link ussevent.Event.verify|verify} messages.
         * @function encode
         * @memberof ussevent.Event
         * @static
         * @param {ussevent.IEvent} message Event message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Event.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.header != null && Object.hasOwnProperty.call(message, "header"))
                $root.ussevent.Header.encode(message.header, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            if (message.body != null && Object.hasOwnProperty.call(message, "body"))
                writer.uint32(/* id 2, wireType 2 =*/18).bytes(message.body);
            return writer;
        };

        /**
         * Encodes the specified Event message, length delimited. Does not implicitly {@link ussevent.Event.verify|verify} messages.
         * @function encodeDelimited
         * @memberof ussevent.Event
         * @static
         * @param {ussevent.IEvent} message Event message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Event.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an Event message from the specified reader or buffer.
         * @function decode
         * @memberof ussevent.Event
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {ussevent.Event} Event
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Event.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.ussevent.Event();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.header = $root.ussevent.Header.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.body = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an Event message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof ussevent.Event
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {ussevent.Event} Event
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Event.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an Event message.
         * @function verify
         * @memberof ussevent.Event
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Event.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.header != null && message.hasOwnProperty("header")) {
                var error = $root.ussevent.Header.verify(message.header);
                if (error)
                    return "header." + error;
            }
            if (message.body != null && message.hasOwnProperty("body"))
                if (!(message.body && typeof message.body.length === "number" || $util.isString(message.body)))
                    return "body: buffer expected";
            return null;
        };

        /**
         * Creates an Event message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof ussevent.Event
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {ussevent.Event} Event
         */
        Event.fromObject = function fromObject(object) {
            if (object instanceof $root.ussevent.Event)
                return object;
            var message = new $root.ussevent.Event();
            if (object.header != null) {
                if (typeof object.header !== "object")
                    throw TypeError(".ussevent.Event.header: object expected");
                message.header = $root.ussevent.Header.fromObject(object.header);
            }
            if (object.body != null)
                if (typeof object.body === "string")
                    $util.base64.decode(object.body, message.body = $util.newBuffer($util.base64.length(object.body)), 0);
                else if (object.body.length)
                    message.body = object.body;
            return message;
        };

        /**
         * Creates a plain object from an Event message. Also converts values to other types if specified.
         * @function toObject
         * @memberof ussevent.Event
         * @static
         * @param {ussevent.Event} message Event
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Event.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.header = null;
                if (options.bytes === String)
                    object.body = "";
                else {
                    object.body = [];
                    if (options.bytes !== Array)
                        object.body = $util.newBuffer(object.body);
                }
            }
            if (message.header != null && message.hasOwnProperty("header"))
                object.header = $root.ussevent.Header.toObject(message.header, options);
            if (message.body != null && message.hasOwnProperty("body"))
                object.body = options.bytes === String ? $util.base64.encode(message.body, 0, message.body.length) : options.bytes === Array ? Array.prototype.slice.call(message.body) : message.body;
            return object;
        };

        /**
         * Converts this Event to JSON.
         * @function toJSON
         * @memberof ussevent.Event
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Event.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return Event;
    })();

    ussevent.Header = (function() {

        /**
         * Properties of a Header.
         * @memberof ussevent
         * @interface IHeader
         * @property {number|null} [id] Header id
         * @property {number|null} [sceneId] Header sceneId
         * @property {number|Long|null} [uid] Header uid
         * @property {string|null} [deviceId] Header deviceId
         * @property {string|null} [deviceModel] Header deviceModel
         * @property {number|null} [os] Header os
         * @property {string|null} [osVersion] Header osVersion
         * @property {string|null} [clientVersion] Header clientVersion
         * @property {string|null} [clientIp] Header clientIp
         * @property {number|null} [network] Header network
         * @property {string|null} [country] Header country
         * @property {string|null} [ua] Header ua
         * @property {string|null} [sdkVersion] Header sdkVersion
         * @property {number|Long|null} [timestamp] Header timestamp
         * @property {number|Long|null} [adjustTimestamp] Header adjustTimestamp
         * @property {number|null} [sdkType] Header sdkType
         * @property {number|null} [bodyFormat] Header bodyFormat
         * @property {string|null} [abTest] Header abTest
         * @property {number|null} [appType] Header appType
         * @property {string|null} [rnVersion] Header rnVersion
         * @property {string|null} [channel] Header channel
         * @property {number|null} [biz] Header biz
         * @property {number|null} [samplePercent] Header samplePercent
         * @property {number|null} [dataSourceType] Header dataSourceType
         */

        /**
         * Constructs a new Header.
         * @memberof ussevent
         * @classdesc Represents a Header.
         * @implements IHeader
         * @constructor
         * @param {ussevent.IHeader=} [properties] Properties to set
         */
        function Header(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Header id.
         * @member {number} id
         * @memberof ussevent.Header
         * @instance
         */
        Header.prototype.id = 0;

        /**
         * Header sceneId.
         * @member {number} sceneId
         * @memberof ussevent.Header
         * @instance
         */
        Header.prototype.sceneId = 0;

        /**
         * Header uid.
         * @member {number|Long} uid
         * @memberof ussevent.Header
         * @instance
         */
        Header.prototype.uid = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * Header deviceId.
         * @member {string} deviceId
         * @memberof ussevent.Header
         * @instance
         */
        Header.prototype.deviceId = "";

        /**
         * Header deviceModel.
         * @member {string} deviceModel
         * @memberof ussevent.Header
         * @instance
         */
        Header.prototype.deviceModel = "";

        /**
         * Header os.
         * @member {number} os
         * @memberof ussevent.Header
         * @instance
         */
        Header.prototype.os = 0;

        /**
         * Header osVersion.
         * @member {string} osVersion
         * @memberof ussevent.Header
         * @instance
         */
        Header.prototype.osVersion = "";

        /**
         * Header clientVersion.
         * @member {string} clientVersion
         * @memberof ussevent.Header
         * @instance
         */
        Header.prototype.clientVersion = "";

        /**
         * Header clientIp.
         * @member {string} clientIp
         * @memberof ussevent.Header
         * @instance
         */
        Header.prototype.clientIp = "";

        /**
         * Header network.
         * @member {number} network
         * @memberof ussevent.Header
         * @instance
         */
        Header.prototype.network = 0;

        /**
         * Header country.
         * @member {string} country
         * @memberof ussevent.Header
         * @instance
         */
        Header.prototype.country = "";

        /**
         * Header ua.
         * @member {string} ua
         * @memberof ussevent.Header
         * @instance
         */
        Header.prototype.ua = "";

        /**
         * Header sdkVersion.
         * @member {string} sdkVersion
         * @memberof ussevent.Header
         * @instance
         */
        Header.prototype.sdkVersion = "";

        /**
         * Header timestamp.
         * @member {number|Long} timestamp
         * @memberof ussevent.Header
         * @instance
         */
        Header.prototype.timestamp = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * Header adjustTimestamp.
         * @member {number|Long} adjustTimestamp
         * @memberof ussevent.Header
         * @instance
         */
        Header.prototype.adjustTimestamp = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * Header sdkType.
         * @member {number} sdkType
         * @memberof ussevent.Header
         * @instance
         */
        Header.prototype.sdkType = 0;

        /**
         * Header bodyFormat.
         * @member {number} bodyFormat
         * @memberof ussevent.Header
         * @instance
         */
        Header.prototype.bodyFormat = 0;

        /**
         * Header abTest.
         * @member {string} abTest
         * @memberof ussevent.Header
         * @instance
         */
        Header.prototype.abTest = "";

        /**
         * Header appType.
         * @member {number} appType
         * @memberof ussevent.Header
         * @instance
         */
        Header.prototype.appType = 0;

        /**
         * Header rnVersion.
         * @member {string} rnVersion
         * @memberof ussevent.Header
         * @instance
         */
        Header.prototype.rnVersion = "";

        /**
         * Header channel.
         * @member {string} channel
         * @memberof ussevent.Header
         * @instance
         */
        Header.prototype.channel = "";

        /**
         * Header biz.
         * @member {number} biz
         * @memberof ussevent.Header
         * @instance
         */
        Header.prototype.biz = 0;

        /**
         * Header samplePercent.
         * @member {number} samplePercent
         * @memberof ussevent.Header
         * @instance
         */
        Header.prototype.samplePercent = 100;

        /**
         * Header dataSourceType.
         * @member {number} dataSourceType
         * @memberof ussevent.Header
         * @instance
         */
        Header.prototype.dataSourceType = 0;

        /**
         * Creates a new Header instance using the specified properties.
         * @function create
         * @memberof ussevent.Header
         * @static
         * @param {ussevent.IHeader=} [properties] Properties to set
         * @returns {ussevent.Header} Header instance
         */
        Header.create = function create(properties) {
            return new Header(properties);
        };

        /**
         * Encodes the specified Header message. Does not implicitly {@link ussevent.Header.verify|verify} messages.
         * @function encode
         * @memberof ussevent.Header
         * @static
         * @param {ussevent.IHeader} message Header message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Header.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.id);
            if (message.sceneId != null && Object.hasOwnProperty.call(message, "sceneId"))
                writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.sceneId);
            if (message.uid != null && Object.hasOwnProperty.call(message, "uid"))
                writer.uint32(/* id 3, wireType 0 =*/24).uint64(message.uid);
            if (message.deviceId != null && Object.hasOwnProperty.call(message, "deviceId"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.deviceId);
            if (message.deviceModel != null && Object.hasOwnProperty.call(message, "deviceModel"))
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.deviceModel);
            if (message.os != null && Object.hasOwnProperty.call(message, "os"))
                writer.uint32(/* id 6, wireType 0 =*/48).uint32(message.os);
            if (message.osVersion != null && Object.hasOwnProperty.call(message, "osVersion"))
                writer.uint32(/* id 7, wireType 2 =*/58).string(message.osVersion);
            if (message.clientVersion != null && Object.hasOwnProperty.call(message, "clientVersion"))
                writer.uint32(/* id 8, wireType 2 =*/66).string(message.clientVersion);
            if (message.clientIp != null && Object.hasOwnProperty.call(message, "clientIp"))
                writer.uint32(/* id 9, wireType 2 =*/74).string(message.clientIp);
            if (message.network != null && Object.hasOwnProperty.call(message, "network"))
                writer.uint32(/* id 10, wireType 0 =*/80).uint32(message.network);
            if (message.country != null && Object.hasOwnProperty.call(message, "country"))
                writer.uint32(/* id 11, wireType 2 =*/90).string(message.country);
            if (message.ua != null && Object.hasOwnProperty.call(message, "ua"))
                writer.uint32(/* id 12, wireType 2 =*/98).string(message.ua);
            if (message.sdkVersion != null && Object.hasOwnProperty.call(message, "sdkVersion"))
                writer.uint32(/* id 13, wireType 2 =*/106).string(message.sdkVersion);
            if (message.timestamp != null && Object.hasOwnProperty.call(message, "timestamp"))
                writer.uint32(/* id 14, wireType 0 =*/112).uint64(message.timestamp);
            if (message.adjustTimestamp != null && Object.hasOwnProperty.call(message, "adjustTimestamp"))
                writer.uint32(/* id 15, wireType 0 =*/120).uint64(message.adjustTimestamp);
            if (message.sdkType != null && Object.hasOwnProperty.call(message, "sdkType"))
                writer.uint32(/* id 16, wireType 0 =*/128).uint32(message.sdkType);
            if (message.bodyFormat != null && Object.hasOwnProperty.call(message, "bodyFormat"))
                writer.uint32(/* id 17, wireType 0 =*/136).uint32(message.bodyFormat);
            if (message.abTest != null && Object.hasOwnProperty.call(message, "abTest"))
                writer.uint32(/* id 18, wireType 2 =*/146).string(message.abTest);
            if (message.appType != null && Object.hasOwnProperty.call(message, "appType"))
                writer.uint32(/* id 19, wireType 0 =*/152).uint32(message.appType);
            if (message.rnVersion != null && Object.hasOwnProperty.call(message, "rnVersion"))
                writer.uint32(/* id 20, wireType 2 =*/162).string(message.rnVersion);
            if (message.channel != null && Object.hasOwnProperty.call(message, "channel"))
                writer.uint32(/* id 21, wireType 2 =*/170).string(message.channel);
            if (message.biz != null && Object.hasOwnProperty.call(message, "biz"))
                writer.uint32(/* id 22, wireType 0 =*/176).uint32(message.biz);
            if (message.samplePercent != null && Object.hasOwnProperty.call(message, "samplePercent"))
                writer.uint32(/* id 23, wireType 0 =*/184).uint32(message.samplePercent);
            if (message.dataSourceType != null && Object.hasOwnProperty.call(message, "dataSourceType"))
                writer.uint32(/* id 24, wireType 0 =*/192).uint32(message.dataSourceType);
            return writer;
        };

        /**
         * Encodes the specified Header message, length delimited. Does not implicitly {@link ussevent.Header.verify|verify} messages.
         * @function encodeDelimited
         * @memberof ussevent.Header
         * @static
         * @param {ussevent.IHeader} message Header message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Header.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a Header message from the specified reader or buffer.
         * @function decode
         * @memberof ussevent.Header
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {ussevent.Header} Header
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Header.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.ussevent.Header();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.id = reader.uint32();
                    break;
                case 2:
                    message.sceneId = reader.uint32();
                    break;
                case 3:
                    message.uid = reader.uint64();
                    break;
                case 4:
                    message.deviceId = reader.string();
                    break;
                case 5:
                    message.deviceModel = reader.string();
                    break;
                case 6:
                    message.os = reader.uint32();
                    break;
                case 7:
                    message.osVersion = reader.string();
                    break;
                case 8:
                    message.clientVersion = reader.string();
                    break;
                case 9:
                    message.clientIp = reader.string();
                    break;
                case 10:
                    message.network = reader.uint32();
                    break;
                case 11:
                    message.country = reader.string();
                    break;
                case 12:
                    message.ua = reader.string();
                    break;
                case 13:
                    message.sdkVersion = reader.string();
                    break;
                case 14:
                    message.timestamp = reader.uint64();
                    break;
                case 15:
                    message.adjustTimestamp = reader.uint64();
                    break;
                case 16:
                    message.sdkType = reader.uint32();
                    break;
                case 17:
                    message.bodyFormat = reader.uint32();
                    break;
                case 18:
                    message.abTest = reader.string();
                    break;
                case 19:
                    message.appType = reader.uint32();
                    break;
                case 20:
                    message.rnVersion = reader.string();
                    break;
                case 21:
                    message.channel = reader.string();
                    break;
                case 22:
                    message.biz = reader.uint32();
                    break;
                case 23:
                    message.samplePercent = reader.uint32();
                    break;
                case 24:
                    message.dataSourceType = reader.uint32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a Header message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof ussevent.Header
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {ussevent.Header} Header
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Header.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a Header message.
         * @function verify
         * @memberof ussevent.Header
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Header.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.id != null && message.hasOwnProperty("id"))
                if (!$util.isInteger(message.id))
                    return "id: integer expected";
            if (message.sceneId != null && message.hasOwnProperty("sceneId"))
                if (!$util.isInteger(message.sceneId))
                    return "sceneId: integer expected";
            if (message.uid != null && message.hasOwnProperty("uid"))
                if (!$util.isInteger(message.uid) && !(message.uid && $util.isInteger(message.uid.low) && $util.isInteger(message.uid.high)))
                    return "uid: integer|Long expected";
            if (message.deviceId != null && message.hasOwnProperty("deviceId"))
                if (!$util.isString(message.deviceId))
                    return "deviceId: string expected";
            if (message.deviceModel != null && message.hasOwnProperty("deviceModel"))
                if (!$util.isString(message.deviceModel))
                    return "deviceModel: string expected";
            if (message.os != null && message.hasOwnProperty("os"))
                if (!$util.isInteger(message.os))
                    return "os: integer expected";
            if (message.osVersion != null && message.hasOwnProperty("osVersion"))
                if (!$util.isString(message.osVersion))
                    return "osVersion: string expected";
            if (message.clientVersion != null && message.hasOwnProperty("clientVersion"))
                if (!$util.isString(message.clientVersion))
                    return "clientVersion: string expected";
            if (message.clientIp != null && message.hasOwnProperty("clientIp"))
                if (!$util.isString(message.clientIp))
                    return "clientIp: string expected";
            if (message.network != null && message.hasOwnProperty("network"))
                if (!$util.isInteger(message.network))
                    return "network: integer expected";
            if (message.country != null && message.hasOwnProperty("country"))
                if (!$util.isString(message.country))
                    return "country: string expected";
            if (message.ua != null && message.hasOwnProperty("ua"))
                if (!$util.isString(message.ua))
                    return "ua: string expected";
            if (message.sdkVersion != null && message.hasOwnProperty("sdkVersion"))
                if (!$util.isString(message.sdkVersion))
                    return "sdkVersion: string expected";
            if (message.timestamp != null && message.hasOwnProperty("timestamp"))
                if (!$util.isInteger(message.timestamp) && !(message.timestamp && $util.isInteger(message.timestamp.low) && $util.isInteger(message.timestamp.high)))
                    return "timestamp: integer|Long expected";
            if (message.adjustTimestamp != null && message.hasOwnProperty("adjustTimestamp"))
                if (!$util.isInteger(message.adjustTimestamp) && !(message.adjustTimestamp && $util.isInteger(message.adjustTimestamp.low) && $util.isInteger(message.adjustTimestamp.high)))
                    return "adjustTimestamp: integer|Long expected";
            if (message.sdkType != null && message.hasOwnProperty("sdkType"))
                if (!$util.isInteger(message.sdkType))
                    return "sdkType: integer expected";
            if (message.bodyFormat != null && message.hasOwnProperty("bodyFormat"))
                if (!$util.isInteger(message.bodyFormat))
                    return "bodyFormat: integer expected";
            if (message.abTest != null && message.hasOwnProperty("abTest"))
                if (!$util.isString(message.abTest))
                    return "abTest: string expected";
            if (message.appType != null && message.hasOwnProperty("appType"))
                if (!$util.isInteger(message.appType))
                    return "appType: integer expected";
            if (message.rnVersion != null && message.hasOwnProperty("rnVersion"))
                if (!$util.isString(message.rnVersion))
                    return "rnVersion: string expected";
            if (message.channel != null && message.hasOwnProperty("channel"))
                if (!$util.isString(message.channel))
                    return "channel: string expected";
            if (message.biz != null && message.hasOwnProperty("biz"))
                if (!$util.isInteger(message.biz))
                    return "biz: integer expected";
            if (message.samplePercent != null && message.hasOwnProperty("samplePercent"))
                if (!$util.isInteger(message.samplePercent))
                    return "samplePercent: integer expected";
            if (message.dataSourceType != null && message.hasOwnProperty("dataSourceType"))
                if (!$util.isInteger(message.dataSourceType))
                    return "dataSourceType: integer expected";
            return null;
        };

        /**
         * Creates a Header message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof ussevent.Header
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {ussevent.Header} Header
         */
        Header.fromObject = function fromObject(object) {
            if (object instanceof $root.ussevent.Header)
                return object;
            var message = new $root.ussevent.Header();
            if (object.id != null)
                message.id = object.id >>> 0;
            if (object.sceneId != null)
                message.sceneId = object.sceneId >>> 0;
            if (object.uid != null)
                if ($util.Long)
                    (message.uid = $util.Long.fromValue(object.uid)).unsigned = true;
                else if (typeof object.uid === "string")
                    message.uid = parseInt(object.uid, 10);
                else if (typeof object.uid === "number")
                    message.uid = object.uid;
                else if (typeof object.uid === "object")
                    message.uid = new $util.LongBits(object.uid.low >>> 0, object.uid.high >>> 0).toNumber(true);
            if (object.deviceId != null)
                message.deviceId = String(object.deviceId);
            if (object.deviceModel != null)
                message.deviceModel = String(object.deviceModel);
            if (object.os != null)
                message.os = object.os >>> 0;
            if (object.osVersion != null)
                message.osVersion = String(object.osVersion);
            if (object.clientVersion != null)
                message.clientVersion = String(object.clientVersion);
            if (object.clientIp != null)
                message.clientIp = String(object.clientIp);
            if (object.network != null)
                message.network = object.network >>> 0;
            if (object.country != null)
                message.country = String(object.country);
            if (object.ua != null)
                message.ua = String(object.ua);
            if (object.sdkVersion != null)
                message.sdkVersion = String(object.sdkVersion);
            if (object.timestamp != null)
                if ($util.Long)
                    (message.timestamp = $util.Long.fromValue(object.timestamp)).unsigned = true;
                else if (typeof object.timestamp === "string")
                    message.timestamp = parseInt(object.timestamp, 10);
                else if (typeof object.timestamp === "number")
                    message.timestamp = object.timestamp;
                else if (typeof object.timestamp === "object")
                    message.timestamp = new $util.LongBits(object.timestamp.low >>> 0, object.timestamp.high >>> 0).toNumber(true);
            if (object.adjustTimestamp != null)
                if ($util.Long)
                    (message.adjustTimestamp = $util.Long.fromValue(object.adjustTimestamp)).unsigned = true;
                else if (typeof object.adjustTimestamp === "string")
                    message.adjustTimestamp = parseInt(object.adjustTimestamp, 10);
                else if (typeof object.adjustTimestamp === "number")
                    message.adjustTimestamp = object.adjustTimestamp;
                else if (typeof object.adjustTimestamp === "object")
                    message.adjustTimestamp = new $util.LongBits(object.adjustTimestamp.low >>> 0, object.adjustTimestamp.high >>> 0).toNumber(true);
            if (object.sdkType != null)
                message.sdkType = object.sdkType >>> 0;
            if (object.bodyFormat != null)
                message.bodyFormat = object.bodyFormat >>> 0;
            if (object.abTest != null)
                message.abTest = String(object.abTest);
            if (object.appType != null)
                message.appType = object.appType >>> 0;
            if (object.rnVersion != null)
                message.rnVersion = String(object.rnVersion);
            if (object.channel != null)
                message.channel = String(object.channel);
            if (object.biz != null)
                message.biz = object.biz >>> 0;
            if (object.samplePercent != null)
                message.samplePercent = object.samplePercent >>> 0;
            if (object.dataSourceType != null)
                message.dataSourceType = object.dataSourceType >>> 0;
            return message;
        };

        /**
         * Creates a plain object from a Header message. Also converts values to other types if specified.
         * @function toObject
         * @memberof ussevent.Header
         * @static
         * @param {ussevent.Header} message Header
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Header.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.id = 0;
                object.sceneId = 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.uid = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.uid = options.longs === String ? "0" : 0;
                object.deviceId = "";
                object.deviceModel = "";
                object.os = 0;
                object.osVersion = "";
                object.clientVersion = "";
                object.clientIp = "";
                object.network = 0;
                object.country = "";
                object.ua = "";
                object.sdkVersion = "";
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.timestamp = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.timestamp = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.adjustTimestamp = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.adjustTimestamp = options.longs === String ? "0" : 0;
                object.sdkType = 0;
                object.bodyFormat = 0;
                object.abTest = "";
                object.appType = 0;
                object.rnVersion = "";
                object.channel = "";
                object.biz = 0;
                object.samplePercent = 100;
                object.dataSourceType = 0;
            }
            if (message.id != null && message.hasOwnProperty("id"))
                object.id = message.id;
            if (message.sceneId != null && message.hasOwnProperty("sceneId"))
                object.sceneId = message.sceneId;
            if (message.uid != null && message.hasOwnProperty("uid"))
                if (typeof message.uid === "number")
                    object.uid = options.longs === String ? String(message.uid) : message.uid;
                else
                    object.uid = options.longs === String ? $util.Long.prototype.toString.call(message.uid) : options.longs === Number ? new $util.LongBits(message.uid.low >>> 0, message.uid.high >>> 0).toNumber(true) : message.uid;
            if (message.deviceId != null && message.hasOwnProperty("deviceId"))
                object.deviceId = message.deviceId;
            if (message.deviceModel != null && message.hasOwnProperty("deviceModel"))
                object.deviceModel = message.deviceModel;
            if (message.os != null && message.hasOwnProperty("os"))
                object.os = message.os;
            if (message.osVersion != null && message.hasOwnProperty("osVersion"))
                object.osVersion = message.osVersion;
            if (message.clientVersion != null && message.hasOwnProperty("clientVersion"))
                object.clientVersion = message.clientVersion;
            if (message.clientIp != null && message.hasOwnProperty("clientIp"))
                object.clientIp = message.clientIp;
            if (message.network != null && message.hasOwnProperty("network"))
                object.network = message.network;
            if (message.country != null && message.hasOwnProperty("country"))
                object.country = message.country;
            if (message.ua != null && message.hasOwnProperty("ua"))
                object.ua = message.ua;
            if (message.sdkVersion != null && message.hasOwnProperty("sdkVersion"))
                object.sdkVersion = message.sdkVersion;
            if (message.timestamp != null && message.hasOwnProperty("timestamp"))
                if (typeof message.timestamp === "number")
                    object.timestamp = options.longs === String ? String(message.timestamp) : message.timestamp;
                else
                    object.timestamp = options.longs === String ? $util.Long.prototype.toString.call(message.timestamp) : options.longs === Number ? new $util.LongBits(message.timestamp.low >>> 0, message.timestamp.high >>> 0).toNumber(true) : message.timestamp;
            if (message.adjustTimestamp != null && message.hasOwnProperty("adjustTimestamp"))
                if (typeof message.adjustTimestamp === "number")
                    object.adjustTimestamp = options.longs === String ? String(message.adjustTimestamp) : message.adjustTimestamp;
                else
                    object.adjustTimestamp = options.longs === String ? $util.Long.prototype.toString.call(message.adjustTimestamp) : options.longs === Number ? new $util.LongBits(message.adjustTimestamp.low >>> 0, message.adjustTimestamp.high >>> 0).toNumber(true) : message.adjustTimestamp;
            if (message.sdkType != null && message.hasOwnProperty("sdkType"))
                object.sdkType = message.sdkType;
            if (message.bodyFormat != null && message.hasOwnProperty("bodyFormat"))
                object.bodyFormat = message.bodyFormat;
            if (message.abTest != null && message.hasOwnProperty("abTest"))
                object.abTest = message.abTest;
            if (message.appType != null && message.hasOwnProperty("appType"))
                object.appType = message.appType;
            if (message.rnVersion != null && message.hasOwnProperty("rnVersion"))
                object.rnVersion = message.rnVersion;
            if (message.channel != null && message.hasOwnProperty("channel"))
                object.channel = message.channel;
            if (message.biz != null && message.hasOwnProperty("biz"))
                object.biz = message.biz;
            if (message.samplePercent != null && message.hasOwnProperty("samplePercent"))
                object.samplePercent = message.samplePercent;
            if (message.dataSourceType != null && message.hasOwnProperty("dataSourceType"))
                object.dataSourceType = message.dataSourceType;
            return object;
        };

        /**
         * Converts this Header to JSON.
         * @function toJSON
         * @memberof ussevent.Header
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Header.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return Header;
    })();

    ussevent.FileTransferEvent = (function() {

        /**
         * Properties of a FileTransferEvent.
         * @memberof ussevent
         * @interface IFileTransferEvent
         * @property {number|null} [actionId] FileTransferEvent actionId
         * @property {string|null} [serviceId] FileTransferEvent serviceId
         * @property {number|null} [serviceIndex] FileTransferEvent serviceIndex
         * @property {string|null} [vid] FileTransferEvent vid
         * @property {number|null} [code] FileTransferEvent code
         * @property {number|null} [sdkCode] FileTransferEvent sdkCode
         * @property {string|null} [extendId] FileTransferEvent extendId
         * @property {number|Long|null} [cost] FileTransferEvent cost
         * @property {number|Long|null} [fsize] FileTransferEvent fsize
         */

        /**
         * Constructs a new FileTransferEvent.
         * @memberof ussevent
         * @classdesc Represents a FileTransferEvent.
         * @implements IFileTransferEvent
         * @constructor
         * @param {ussevent.IFileTransferEvent=} [properties] Properties to set
         */
        function FileTransferEvent(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * FileTransferEvent actionId.
         * @member {number} actionId
         * @memberof ussevent.FileTransferEvent
         * @instance
         */
        FileTransferEvent.prototype.actionId = 0;

        /**
         * FileTransferEvent serviceId.
         * @member {string} serviceId
         * @memberof ussevent.FileTransferEvent
         * @instance
         */
        FileTransferEvent.prototype.serviceId = "";

        /**
         * FileTransferEvent serviceIndex.
         * @member {number} serviceIndex
         * @memberof ussevent.FileTransferEvent
         * @instance
         */
        FileTransferEvent.prototype.serviceIndex = 0;

        /**
         * FileTransferEvent vid.
         * @member {string} vid
         * @memberof ussevent.FileTransferEvent
         * @instance
         */
        FileTransferEvent.prototype.vid = "";

        /**
         * FileTransferEvent code.
         * @member {number} code
         * @memberof ussevent.FileTransferEvent
         * @instance
         */
        FileTransferEvent.prototype.code = 0;

        /**
         * FileTransferEvent sdkCode.
         * @member {number} sdkCode
         * @memberof ussevent.FileTransferEvent
         * @instance
         */
        FileTransferEvent.prototype.sdkCode = 0;

        /**
         * FileTransferEvent extendId.
         * @member {string} extendId
         * @memberof ussevent.FileTransferEvent
         * @instance
         */
        FileTransferEvent.prototype.extendId = "";

        /**
         * FileTransferEvent cost.
         * @member {number|Long} cost
         * @memberof ussevent.FileTransferEvent
         * @instance
         */
        FileTransferEvent.prototype.cost = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * FileTransferEvent fsize.
         * @member {number|Long} fsize
         * @memberof ussevent.FileTransferEvent
         * @instance
         */
        FileTransferEvent.prototype.fsize = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * Creates a new FileTransferEvent instance using the specified properties.
         * @function create
         * @memberof ussevent.FileTransferEvent
         * @static
         * @param {ussevent.IFileTransferEvent=} [properties] Properties to set
         * @returns {ussevent.FileTransferEvent} FileTransferEvent instance
         */
        FileTransferEvent.create = function create(properties) {
            return new FileTransferEvent(properties);
        };

        /**
         * Encodes the specified FileTransferEvent message. Does not implicitly {@link ussevent.FileTransferEvent.verify|verify} messages.
         * @function encode
         * @memberof ussevent.FileTransferEvent
         * @static
         * @param {ussevent.IFileTransferEvent} message FileTransferEvent message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        FileTransferEvent.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.actionId != null && Object.hasOwnProperty.call(message, "actionId"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.actionId);
            if (message.serviceId != null && Object.hasOwnProperty.call(message, "serviceId"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.serviceId);
            if (message.serviceIndex != null && Object.hasOwnProperty.call(message, "serviceIndex"))
                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.serviceIndex);
            if (message.vid != null && Object.hasOwnProperty.call(message, "vid"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.vid);
            if (message.code != null && Object.hasOwnProperty.call(message, "code"))
                writer.uint32(/* id 5, wireType 0 =*/40).int32(message.code);
            if (message.sdkCode != null && Object.hasOwnProperty.call(message, "sdkCode"))
                writer.uint32(/* id 6, wireType 0 =*/48).int32(message.sdkCode);
            if (message.extendId != null && Object.hasOwnProperty.call(message, "extendId"))
                writer.uint32(/* id 7, wireType 2 =*/58).string(message.extendId);
            if (message.cost != null && Object.hasOwnProperty.call(message, "cost"))
                writer.uint32(/* id 8, wireType 0 =*/64).uint64(message.cost);
            if (message.fsize != null && Object.hasOwnProperty.call(message, "fsize"))
                writer.uint32(/* id 9, wireType 0 =*/72).uint64(message.fsize);
            return writer;
        };

        /**
         * Encodes the specified FileTransferEvent message, length delimited. Does not implicitly {@link ussevent.FileTransferEvent.verify|verify} messages.
         * @function encodeDelimited
         * @memberof ussevent.FileTransferEvent
         * @static
         * @param {ussevent.IFileTransferEvent} message FileTransferEvent message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        FileTransferEvent.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a FileTransferEvent message from the specified reader or buffer.
         * @function decode
         * @memberof ussevent.FileTransferEvent
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {ussevent.FileTransferEvent} FileTransferEvent
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        FileTransferEvent.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.ussevent.FileTransferEvent();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.actionId = reader.int32();
                    break;
                case 2:
                    message.serviceId = reader.string();
                    break;
                case 3:
                    message.serviceIndex = reader.int32();
                    break;
                case 4:
                    message.vid = reader.string();
                    break;
                case 5:
                    message.code = reader.int32();
                    break;
                case 6:
                    message.sdkCode = reader.int32();
                    break;
                case 7:
                    message.extendId = reader.string();
                    break;
                case 8:
                    message.cost = reader.uint64();
                    break;
                case 9:
                    message.fsize = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a FileTransferEvent message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof ussevent.FileTransferEvent
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {ussevent.FileTransferEvent} FileTransferEvent
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        FileTransferEvent.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a FileTransferEvent message.
         * @function verify
         * @memberof ussevent.FileTransferEvent
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        FileTransferEvent.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.actionId != null && message.hasOwnProperty("actionId"))
                if (!$util.isInteger(message.actionId))
                    return "actionId: integer expected";
            if (message.serviceId != null && message.hasOwnProperty("serviceId"))
                if (!$util.isString(message.serviceId))
                    return "serviceId: string expected";
            if (message.serviceIndex != null && message.hasOwnProperty("serviceIndex"))
                if (!$util.isInteger(message.serviceIndex))
                    return "serviceIndex: integer expected";
            if (message.vid != null && message.hasOwnProperty("vid"))
                if (!$util.isString(message.vid))
                    return "vid: string expected";
            if (message.code != null && message.hasOwnProperty("code"))
                if (!$util.isInteger(message.code))
                    return "code: integer expected";
            if (message.sdkCode != null && message.hasOwnProperty("sdkCode"))
                if (!$util.isInteger(message.sdkCode))
                    return "sdkCode: integer expected";
            if (message.extendId != null && message.hasOwnProperty("extendId"))
                if (!$util.isString(message.extendId))
                    return "extendId: string expected";
            if (message.cost != null && message.hasOwnProperty("cost"))
                if (!$util.isInteger(message.cost) && !(message.cost && $util.isInteger(message.cost.low) && $util.isInteger(message.cost.high)))
                    return "cost: integer|Long expected";
            if (message.fsize != null && message.hasOwnProperty("fsize"))
                if (!$util.isInteger(message.fsize) && !(message.fsize && $util.isInteger(message.fsize.low) && $util.isInteger(message.fsize.high)))
                    return "fsize: integer|Long expected";
            return null;
        };

        /**
         * Creates a FileTransferEvent message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof ussevent.FileTransferEvent
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {ussevent.FileTransferEvent} FileTransferEvent
         */
        FileTransferEvent.fromObject = function fromObject(object) {
            if (object instanceof $root.ussevent.FileTransferEvent)
                return object;
            var message = new $root.ussevent.FileTransferEvent();
            if (object.actionId != null)
                message.actionId = object.actionId | 0;
            if (object.serviceId != null)
                message.serviceId = String(object.serviceId);
            if (object.serviceIndex != null)
                message.serviceIndex = object.serviceIndex | 0;
            if (object.vid != null)
                message.vid = String(object.vid);
            if (object.code != null)
                message.code = object.code | 0;
            if (object.sdkCode != null)
                message.sdkCode = object.sdkCode | 0;
            if (object.extendId != null)
                message.extendId = String(object.extendId);
            if (object.cost != null)
                if ($util.Long)
                    (message.cost = $util.Long.fromValue(object.cost)).unsigned = true;
                else if (typeof object.cost === "string")
                    message.cost = parseInt(object.cost, 10);
                else if (typeof object.cost === "number")
                    message.cost = object.cost;
                else if (typeof object.cost === "object")
                    message.cost = new $util.LongBits(object.cost.low >>> 0, object.cost.high >>> 0).toNumber(true);
            if (object.fsize != null)
                if ($util.Long)
                    (message.fsize = $util.Long.fromValue(object.fsize)).unsigned = true;
                else if (typeof object.fsize === "string")
                    message.fsize = parseInt(object.fsize, 10);
                else if (typeof object.fsize === "number")
                    message.fsize = object.fsize;
                else if (typeof object.fsize === "object")
                    message.fsize = new $util.LongBits(object.fsize.low >>> 0, object.fsize.high >>> 0).toNumber(true);
            return message;
        };

        /**
         * Creates a plain object from a FileTransferEvent message. Also converts values to other types if specified.
         * @function toObject
         * @memberof ussevent.FileTransferEvent
         * @static
         * @param {ussevent.FileTransferEvent} message FileTransferEvent
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        FileTransferEvent.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.actionId = 0;
                object.serviceId = "";
                object.serviceIndex = 0;
                object.vid = "";
                object.code = 0;
                object.sdkCode = 0;
                object.extendId = "";
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.cost = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.cost = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.fsize = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.fsize = options.longs === String ? "0" : 0;
            }
            if (message.actionId != null && message.hasOwnProperty("actionId"))
                object.actionId = message.actionId;
            if (message.serviceId != null && message.hasOwnProperty("serviceId"))
                object.serviceId = message.serviceId;
            if (message.serviceIndex != null && message.hasOwnProperty("serviceIndex"))
                object.serviceIndex = message.serviceIndex;
            if (message.vid != null && message.hasOwnProperty("vid"))
                object.vid = message.vid;
            if (message.code != null && message.hasOwnProperty("code"))
                object.code = message.code;
            if (message.sdkCode != null && message.hasOwnProperty("sdkCode"))
                object.sdkCode = message.sdkCode;
            if (message.extendId != null && message.hasOwnProperty("extendId"))
                object.extendId = message.extendId;
            if (message.cost != null && message.hasOwnProperty("cost"))
                if (typeof message.cost === "number")
                    object.cost = options.longs === String ? String(message.cost) : message.cost;
                else
                    object.cost = options.longs === String ? $util.Long.prototype.toString.call(message.cost) : options.longs === Number ? new $util.LongBits(message.cost.low >>> 0, message.cost.high >>> 0).toNumber(true) : message.cost;
            if (message.fsize != null && message.hasOwnProperty("fsize"))
                if (typeof message.fsize === "number")
                    object.fsize = options.longs === String ? String(message.fsize) : message.fsize;
                else
                    object.fsize = options.longs === String ? $util.Long.prototype.toString.call(message.fsize) : options.longs === Number ? new $util.LongBits(message.fsize.low >>> 0, message.fsize.high >>> 0).toNumber(true) : message.fsize;
            return object;
        };

        /**
         * Converts this FileTransferEvent to JSON.
         * @function toJSON
         * @memberof ussevent.FileTransferEvent
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        FileTransferEvent.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return FileTransferEvent;
    })();

    ussevent.ImgGetStrategyEvent = (function() {

        /**
         * Properties of an ImgGetStrategyEvent.
         * @memberof ussevent
         * @interface IImgGetStrategyEvent
         * @property {number} actionId ImgGetStrategyEvent actionId
         * @property {number|null} [ver] ImgGetStrategyEvent ver
         * @property {number|null} [cost] ImgGetStrategyEvent cost
         */

        /**
         * Constructs a new ImgGetStrategyEvent.
         * @memberof ussevent
         * @classdesc Represents an ImgGetStrategyEvent.
         * @implements IImgGetStrategyEvent
         * @constructor
         * @param {ussevent.IImgGetStrategyEvent=} [properties] Properties to set
         */
        function ImgGetStrategyEvent(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ImgGetStrategyEvent actionId.
         * @member {number} actionId
         * @memberof ussevent.ImgGetStrategyEvent
         * @instance
         */
        ImgGetStrategyEvent.prototype.actionId = 0;

        /**
         * ImgGetStrategyEvent ver.
         * @member {number} ver
         * @memberof ussevent.ImgGetStrategyEvent
         * @instance
         */
        ImgGetStrategyEvent.prototype.ver = 0;

        /**
         * ImgGetStrategyEvent cost.
         * @member {number} cost
         * @memberof ussevent.ImgGetStrategyEvent
         * @instance
         */
        ImgGetStrategyEvent.prototype.cost = 0;

        /**
         * Creates a new ImgGetStrategyEvent instance using the specified properties.
         * @function create
         * @memberof ussevent.ImgGetStrategyEvent
         * @static
         * @param {ussevent.IImgGetStrategyEvent=} [properties] Properties to set
         * @returns {ussevent.ImgGetStrategyEvent} ImgGetStrategyEvent instance
         */
        ImgGetStrategyEvent.create = function create(properties) {
            return new ImgGetStrategyEvent(properties);
        };

        /**
         * Encodes the specified ImgGetStrategyEvent message. Does not implicitly {@link ussevent.ImgGetStrategyEvent.verify|verify} messages.
         * @function encode
         * @memberof ussevent.ImgGetStrategyEvent
         * @static
         * @param {ussevent.IImgGetStrategyEvent} message ImgGetStrategyEvent message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ImgGetStrategyEvent.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.actionId);
            if (message.ver != null && Object.hasOwnProperty.call(message, "ver"))
                writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.ver);
            if (message.cost != null && Object.hasOwnProperty.call(message, "cost"))
                writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.cost);
            return writer;
        };

        /**
         * Encodes the specified ImgGetStrategyEvent message, length delimited. Does not implicitly {@link ussevent.ImgGetStrategyEvent.verify|verify} messages.
         * @function encodeDelimited
         * @memberof ussevent.ImgGetStrategyEvent
         * @static
         * @param {ussevent.IImgGetStrategyEvent} message ImgGetStrategyEvent message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ImgGetStrategyEvent.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an ImgGetStrategyEvent message from the specified reader or buffer.
         * @function decode
         * @memberof ussevent.ImgGetStrategyEvent
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {ussevent.ImgGetStrategyEvent} ImgGetStrategyEvent
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ImgGetStrategyEvent.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.ussevent.ImgGetStrategyEvent();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.actionId = reader.uint32();
                    break;
                case 2:
                    message.ver = reader.uint32();
                    break;
                case 3:
                    message.cost = reader.uint32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            if (!message.hasOwnProperty("actionId"))
                throw $util.ProtocolError("missing required 'actionId'", { instance: message });
            return message;
        };

        /**
         * Decodes an ImgGetStrategyEvent message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof ussevent.ImgGetStrategyEvent
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {ussevent.ImgGetStrategyEvent} ImgGetStrategyEvent
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ImgGetStrategyEvent.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an ImgGetStrategyEvent message.
         * @function verify
         * @memberof ussevent.ImgGetStrategyEvent
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ImgGetStrategyEvent.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (!$util.isInteger(message.actionId))
                return "actionId: integer expected";
            if (message.ver != null && message.hasOwnProperty("ver"))
                if (!$util.isInteger(message.ver))
                    return "ver: integer expected";
            if (message.cost != null && message.hasOwnProperty("cost"))
                if (!$util.isInteger(message.cost))
                    return "cost: integer expected";
            return null;
        };

        /**
         * Creates an ImgGetStrategyEvent message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof ussevent.ImgGetStrategyEvent
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {ussevent.ImgGetStrategyEvent} ImgGetStrategyEvent
         */
        ImgGetStrategyEvent.fromObject = function fromObject(object) {
            if (object instanceof $root.ussevent.ImgGetStrategyEvent)
                return object;
            var message = new $root.ussevent.ImgGetStrategyEvent();
            if (object.actionId != null)
                message.actionId = object.actionId >>> 0;
            if (object.ver != null)
                message.ver = object.ver >>> 0;
            if (object.cost != null)
                message.cost = object.cost >>> 0;
            return message;
        };

        /**
         * Creates a plain object from an ImgGetStrategyEvent message. Also converts values to other types if specified.
         * @function toObject
         * @memberof ussevent.ImgGetStrategyEvent
         * @static
         * @param {ussevent.ImgGetStrategyEvent} message ImgGetStrategyEvent
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ImgGetStrategyEvent.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.actionId = 0;
                object.ver = 0;
                object.cost = 0;
            }
            if (message.actionId != null && message.hasOwnProperty("actionId"))
                object.actionId = message.actionId;
            if (message.ver != null && message.hasOwnProperty("ver"))
                object.ver = message.ver;
            if (message.cost != null && message.hasOwnProperty("cost"))
                object.cost = message.cost;
            return object;
        };

        /**
         * Converts this ImgGetStrategyEvent to JSON.
         * @function toJSON
         * @memberof ussevent.ImgGetStrategyEvent
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ImgGetStrategyEvent.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ImgGetStrategyEvent;
    })();

    ussevent.ImgCompressEvent = (function() {

        /**
         * Properties of an ImgCompressEvent.
         * @memberof ussevent
         * @interface IImgCompressEvent
         * @property {number} actionId ImgCompressEvent actionId
         * @property {number} type ImgCompressEvent type
         * @property {number|null} [quality] ImgCompressEvent quality
         * @property {number|null} [scale] ImgCompressEvent scale
         * @property {number|null} [bSize] ImgCompressEvent bSize
         * @property {number} aSize ImgCompressEvent aSize
         * @property {number} cost ImgCompressEvent cost
         */

        /**
         * Constructs a new ImgCompressEvent.
         * @memberof ussevent
         * @classdesc Represents an ImgCompressEvent.
         * @implements IImgCompressEvent
         * @constructor
         * @param {ussevent.IImgCompressEvent=} [properties] Properties to set
         */
        function ImgCompressEvent(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ImgCompressEvent actionId.
         * @member {number} actionId
         * @memberof ussevent.ImgCompressEvent
         * @instance
         */
        ImgCompressEvent.prototype.actionId = 0;

        /**
         * ImgCompressEvent type.
         * @member {number} type
         * @memberof ussevent.ImgCompressEvent
         * @instance
         */
        ImgCompressEvent.prototype.type = 0;

        /**
         * ImgCompressEvent quality.
         * @member {number} quality
         * @memberof ussevent.ImgCompressEvent
         * @instance
         */
        ImgCompressEvent.prototype.quality = 0;

        /**
         * ImgCompressEvent scale.
         * @member {number} scale
         * @memberof ussevent.ImgCompressEvent
         * @instance
         */
        ImgCompressEvent.prototype.scale = 0;

        /**
         * ImgCompressEvent bSize.
         * @member {number} bSize
         * @memberof ussevent.ImgCompressEvent
         * @instance
         */
        ImgCompressEvent.prototype.bSize = 0;

        /**
         * ImgCompressEvent aSize.
         * @member {number} aSize
         * @memberof ussevent.ImgCompressEvent
         * @instance
         */
        ImgCompressEvent.prototype.aSize = 0;

        /**
         * ImgCompressEvent cost.
         * @member {number} cost
         * @memberof ussevent.ImgCompressEvent
         * @instance
         */
        ImgCompressEvent.prototype.cost = 0;

        /**
         * Creates a new ImgCompressEvent instance using the specified properties.
         * @function create
         * @memberof ussevent.ImgCompressEvent
         * @static
         * @param {ussevent.IImgCompressEvent=} [properties] Properties to set
         * @returns {ussevent.ImgCompressEvent} ImgCompressEvent instance
         */
        ImgCompressEvent.create = function create(properties) {
            return new ImgCompressEvent(properties);
        };

        /**
         * Encodes the specified ImgCompressEvent message. Does not implicitly {@link ussevent.ImgCompressEvent.verify|verify} messages.
         * @function encode
         * @memberof ussevent.ImgCompressEvent
         * @static
         * @param {ussevent.IImgCompressEvent} message ImgCompressEvent message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ImgCompressEvent.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.actionId);
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.type);
            if (message.quality != null && Object.hasOwnProperty.call(message, "quality"))
                writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.quality);
            if (message.scale != null && Object.hasOwnProperty.call(message, "scale"))
                writer.uint32(/* id 4, wireType 5 =*/37).float(message.scale);
            if (message.bSize != null && Object.hasOwnProperty.call(message, "bSize"))
                writer.uint32(/* id 5, wireType 0 =*/40).uint32(message.bSize);
            writer.uint32(/* id 6, wireType 0 =*/48).uint32(message.aSize);
            writer.uint32(/* id 7, wireType 0 =*/56).uint32(message.cost);
            return writer;
        };

        /**
         * Encodes the specified ImgCompressEvent message, length delimited. Does not implicitly {@link ussevent.ImgCompressEvent.verify|verify} messages.
         * @function encodeDelimited
         * @memberof ussevent.ImgCompressEvent
         * @static
         * @param {ussevent.IImgCompressEvent} message ImgCompressEvent message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ImgCompressEvent.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an ImgCompressEvent message from the specified reader or buffer.
         * @function decode
         * @memberof ussevent.ImgCompressEvent
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {ussevent.ImgCompressEvent} ImgCompressEvent
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ImgCompressEvent.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.ussevent.ImgCompressEvent();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.actionId = reader.uint32();
                    break;
                case 2:
                    message.type = reader.uint32();
                    break;
                case 3:
                    message.quality = reader.uint32();
                    break;
                case 4:
                    message.scale = reader.float();
                    break;
                case 5:
                    message.bSize = reader.uint32();
                    break;
                case 6:
                    message.aSize = reader.uint32();
                    break;
                case 7:
                    message.cost = reader.uint32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            if (!message.hasOwnProperty("actionId"))
                throw $util.ProtocolError("missing required 'actionId'", { instance: message });
            if (!message.hasOwnProperty("type"))
                throw $util.ProtocolError("missing required 'type'", { instance: message });
            if (!message.hasOwnProperty("aSize"))
                throw $util.ProtocolError("missing required 'aSize'", { instance: message });
            if (!message.hasOwnProperty("cost"))
                throw $util.ProtocolError("missing required 'cost'", { instance: message });
            return message;
        };

        /**
         * Decodes an ImgCompressEvent message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof ussevent.ImgCompressEvent
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {ussevent.ImgCompressEvent} ImgCompressEvent
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ImgCompressEvent.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an ImgCompressEvent message.
         * @function verify
         * @memberof ussevent.ImgCompressEvent
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ImgCompressEvent.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (!$util.isInteger(message.actionId))
                return "actionId: integer expected";
            if (!$util.isInteger(message.type))
                return "type: integer expected";
            if (message.quality != null && message.hasOwnProperty("quality"))
                if (!$util.isInteger(message.quality))
                    return "quality: integer expected";
            if (message.scale != null && message.hasOwnProperty("scale"))
                if (typeof message.scale !== "number")
                    return "scale: number expected";
            if (message.bSize != null && message.hasOwnProperty("bSize"))
                if (!$util.isInteger(message.bSize))
                    return "bSize: integer expected";
            if (!$util.isInteger(message.aSize))
                return "aSize: integer expected";
            if (!$util.isInteger(message.cost))
                return "cost: integer expected";
            return null;
        };

        /**
         * Creates an ImgCompressEvent message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof ussevent.ImgCompressEvent
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {ussevent.ImgCompressEvent} ImgCompressEvent
         */
        ImgCompressEvent.fromObject = function fromObject(object) {
            if (object instanceof $root.ussevent.ImgCompressEvent)
                return object;
            var message = new $root.ussevent.ImgCompressEvent();
            if (object.actionId != null)
                message.actionId = object.actionId >>> 0;
            if (object.type != null)
                message.type = object.type >>> 0;
            if (object.quality != null)
                message.quality = object.quality >>> 0;
            if (object.scale != null)
                message.scale = Number(object.scale);
            if (object.bSize != null)
                message.bSize = object.bSize >>> 0;
            if (object.aSize != null)
                message.aSize = object.aSize >>> 0;
            if (object.cost != null)
                message.cost = object.cost >>> 0;
            return message;
        };

        /**
         * Creates a plain object from an ImgCompressEvent message. Also converts values to other types if specified.
         * @function toObject
         * @memberof ussevent.ImgCompressEvent
         * @static
         * @param {ussevent.ImgCompressEvent} message ImgCompressEvent
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ImgCompressEvent.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.actionId = 0;
                object.type = 0;
                object.quality = 0;
                object.scale = 0;
                object.bSize = 0;
                object.aSize = 0;
                object.cost = 0;
            }
            if (message.actionId != null && message.hasOwnProperty("actionId"))
                object.actionId = message.actionId;
            if (message.type != null && message.hasOwnProperty("type"))
                object.type = message.type;
            if (message.quality != null && message.hasOwnProperty("quality"))
                object.quality = message.quality;
            if (message.scale != null && message.hasOwnProperty("scale"))
                object.scale = options.json && !isFinite(message.scale) ? String(message.scale) : message.scale;
            if (message.bSize != null && message.hasOwnProperty("bSize"))
                object.bSize = message.bSize;
            if (message.aSize != null && message.hasOwnProperty("aSize"))
                object.aSize = message.aSize;
            if (message.cost != null && message.hasOwnProperty("cost"))
                object.cost = message.cost;
            return object;
        };

        /**
         * Converts this ImgCompressEvent to JSON.
         * @function toJSON
         * @memberof ussevent.ImgCompressEvent
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ImgCompressEvent.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ImgCompressEvent;
    })();

    ussevent.ImgPreuploadEvent = (function() {

        /**
         * Properties of an ImgPreuploadEvent.
         * @memberof ussevent
         * @interface IImgPreuploadEvent
         * @property {number} actionId ImgPreuploadEvent actionId
         * @property {number|null} [serviceLen] ImgPreuploadEvent serviceLen
         * @property {string|null} [firstServiceId] ImgPreuploadEvent firstServiceId
         * @property {number|null} [imgIdsLen] ImgPreuploadEvent imgIdsLen
         * @property {number|null} [cost] ImgPreuploadEvent cost
         * @property {number} strategyVer ImgPreuploadEvent strategyVer
         */

        /**
         * Constructs a new ImgPreuploadEvent.
         * @memberof ussevent
         * @classdesc Represents an ImgPreuploadEvent.
         * @implements IImgPreuploadEvent
         * @constructor
         * @param {ussevent.IImgPreuploadEvent=} [properties] Properties to set
         */
        function ImgPreuploadEvent(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ImgPreuploadEvent actionId.
         * @member {number} actionId
         * @memberof ussevent.ImgPreuploadEvent
         * @instance
         */
        ImgPreuploadEvent.prototype.actionId = 0;

        /**
         * ImgPreuploadEvent serviceLen.
         * @member {number} serviceLen
         * @memberof ussevent.ImgPreuploadEvent
         * @instance
         */
        ImgPreuploadEvent.prototype.serviceLen = 0;

        /**
         * ImgPreuploadEvent firstServiceId.
         * @member {string} firstServiceId
         * @memberof ussevent.ImgPreuploadEvent
         * @instance
         */
        ImgPreuploadEvent.prototype.firstServiceId = "";

        /**
         * ImgPreuploadEvent imgIdsLen.
         * @member {number} imgIdsLen
         * @memberof ussevent.ImgPreuploadEvent
         * @instance
         */
        ImgPreuploadEvent.prototype.imgIdsLen = 0;

        /**
         * ImgPreuploadEvent cost.
         * @member {number} cost
         * @memberof ussevent.ImgPreuploadEvent
         * @instance
         */
        ImgPreuploadEvent.prototype.cost = 0;

        /**
         * ImgPreuploadEvent strategyVer.
         * @member {number} strategyVer
         * @memberof ussevent.ImgPreuploadEvent
         * @instance
         */
        ImgPreuploadEvent.prototype.strategyVer = 0;

        /**
         * Creates a new ImgPreuploadEvent instance using the specified properties.
         * @function create
         * @memberof ussevent.ImgPreuploadEvent
         * @static
         * @param {ussevent.IImgPreuploadEvent=} [properties] Properties to set
         * @returns {ussevent.ImgPreuploadEvent} ImgPreuploadEvent instance
         */
        ImgPreuploadEvent.create = function create(properties) {
            return new ImgPreuploadEvent(properties);
        };

        /**
         * Encodes the specified ImgPreuploadEvent message. Does not implicitly {@link ussevent.ImgPreuploadEvent.verify|verify} messages.
         * @function encode
         * @memberof ussevent.ImgPreuploadEvent
         * @static
         * @param {ussevent.IImgPreuploadEvent} message ImgPreuploadEvent message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ImgPreuploadEvent.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.actionId);
            if (message.serviceLen != null && Object.hasOwnProperty.call(message, "serviceLen"))
                writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.serviceLen);
            if (message.firstServiceId != null && Object.hasOwnProperty.call(message, "firstServiceId"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.firstServiceId);
            if (message.imgIdsLen != null && Object.hasOwnProperty.call(message, "imgIdsLen"))
                writer.uint32(/* id 4, wireType 0 =*/32).uint32(message.imgIdsLen);
            if (message.cost != null && Object.hasOwnProperty.call(message, "cost"))
                writer.uint32(/* id 5, wireType 0 =*/40).uint32(message.cost);
            writer.uint32(/* id 6, wireType 0 =*/48).uint32(message.strategyVer);
            return writer;
        };

        /**
         * Encodes the specified ImgPreuploadEvent message, length delimited. Does not implicitly {@link ussevent.ImgPreuploadEvent.verify|verify} messages.
         * @function encodeDelimited
         * @memberof ussevent.ImgPreuploadEvent
         * @static
         * @param {ussevent.IImgPreuploadEvent} message ImgPreuploadEvent message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ImgPreuploadEvent.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an ImgPreuploadEvent message from the specified reader or buffer.
         * @function decode
         * @memberof ussevent.ImgPreuploadEvent
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {ussevent.ImgPreuploadEvent} ImgPreuploadEvent
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ImgPreuploadEvent.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.ussevent.ImgPreuploadEvent();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.actionId = reader.uint32();
                    break;
                case 2:
                    message.serviceLen = reader.uint32();
                    break;
                case 3:
                    message.firstServiceId = reader.string();
                    break;
                case 4:
                    message.imgIdsLen = reader.uint32();
                    break;
                case 5:
                    message.cost = reader.uint32();
                    break;
                case 6:
                    message.strategyVer = reader.uint32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            if (!message.hasOwnProperty("actionId"))
                throw $util.ProtocolError("missing required 'actionId'", { instance: message });
            if (!message.hasOwnProperty("strategyVer"))
                throw $util.ProtocolError("missing required 'strategyVer'", { instance: message });
            return message;
        };

        /**
         * Decodes an ImgPreuploadEvent message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof ussevent.ImgPreuploadEvent
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {ussevent.ImgPreuploadEvent} ImgPreuploadEvent
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ImgPreuploadEvent.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an ImgPreuploadEvent message.
         * @function verify
         * @memberof ussevent.ImgPreuploadEvent
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ImgPreuploadEvent.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (!$util.isInteger(message.actionId))
                return "actionId: integer expected";
            if (message.serviceLen != null && message.hasOwnProperty("serviceLen"))
                if (!$util.isInteger(message.serviceLen))
                    return "serviceLen: integer expected";
            if (message.firstServiceId != null && message.hasOwnProperty("firstServiceId"))
                if (!$util.isString(message.firstServiceId))
                    return "firstServiceId: string expected";
            if (message.imgIdsLen != null && message.hasOwnProperty("imgIdsLen"))
                if (!$util.isInteger(message.imgIdsLen))
                    return "imgIdsLen: integer expected";
            if (message.cost != null && message.hasOwnProperty("cost"))
                if (!$util.isInteger(message.cost))
                    return "cost: integer expected";
            if (!$util.isInteger(message.strategyVer))
                return "strategyVer: integer expected";
            return null;
        };

        /**
         * Creates an ImgPreuploadEvent message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof ussevent.ImgPreuploadEvent
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {ussevent.ImgPreuploadEvent} ImgPreuploadEvent
         */
        ImgPreuploadEvent.fromObject = function fromObject(object) {
            if (object instanceof $root.ussevent.ImgPreuploadEvent)
                return object;
            var message = new $root.ussevent.ImgPreuploadEvent();
            if (object.actionId != null)
                message.actionId = object.actionId >>> 0;
            if (object.serviceLen != null)
                message.serviceLen = object.serviceLen >>> 0;
            if (object.firstServiceId != null)
                message.firstServiceId = String(object.firstServiceId);
            if (object.imgIdsLen != null)
                message.imgIdsLen = object.imgIdsLen >>> 0;
            if (object.cost != null)
                message.cost = object.cost >>> 0;
            if (object.strategyVer != null)
                message.strategyVer = object.strategyVer >>> 0;
            return message;
        };

        /**
         * Creates a plain object from an ImgPreuploadEvent message. Also converts values to other types if specified.
         * @function toObject
         * @memberof ussevent.ImgPreuploadEvent
         * @static
         * @param {ussevent.ImgPreuploadEvent} message ImgPreuploadEvent
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ImgPreuploadEvent.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.actionId = 0;
                object.serviceLen = 0;
                object.firstServiceId = "";
                object.imgIdsLen = 0;
                object.cost = 0;
                object.strategyVer = 0;
            }
            if (message.actionId != null && message.hasOwnProperty("actionId"))
                object.actionId = message.actionId;
            if (message.serviceLen != null && message.hasOwnProperty("serviceLen"))
                object.serviceLen = message.serviceLen;
            if (message.firstServiceId != null && message.hasOwnProperty("firstServiceId"))
                object.firstServiceId = message.firstServiceId;
            if (message.imgIdsLen != null && message.hasOwnProperty("imgIdsLen"))
                object.imgIdsLen = message.imgIdsLen;
            if (message.cost != null && message.hasOwnProperty("cost"))
                object.cost = message.cost;
            if (message.strategyVer != null && message.hasOwnProperty("strategyVer"))
                object.strategyVer = message.strategyVer;
            return object;
        };

        /**
         * Converts this ImgPreuploadEvent to JSON.
         * @function toJSON
         * @memberof ussevent.ImgPreuploadEvent
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ImgPreuploadEvent.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ImgPreuploadEvent;
    })();

    ussevent.ImgFileTransferEvent = (function() {

        /**
         * Properties of an ImgFileTransferEvent.
         * @memberof ussevent
         * @interface IImgFileTransferEvent
         * @property {number} actionId ImgFileTransferEvent actionId
         * @property {string} serviceId ImgFileTransferEvent serviceId
         * @property {number} serviceIdx ImgFileTransferEvent serviceIdx
         * @property {string} imgid ImgFileTransferEvent imgid
         * @property {number} code ImgFileTransferEvent code
         * @property {string|null} [extendId] ImgFileTransferEvent extendId
         * @property {number|null} [cost] ImgFileTransferEvent cost
         * @property {number|null} [fsize] ImgFileTransferEvent fsize
         * @property {number} strategyVer ImgFileTransferEvent strategyVer
         */

        /**
         * Constructs a new ImgFileTransferEvent.
         * @memberof ussevent
         * @classdesc Represents an ImgFileTransferEvent.
         * @implements IImgFileTransferEvent
         * @constructor
         * @param {ussevent.IImgFileTransferEvent=} [properties] Properties to set
         */
        function ImgFileTransferEvent(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ImgFileTransferEvent actionId.
         * @member {number} actionId
         * @memberof ussevent.ImgFileTransferEvent
         * @instance
         */
        ImgFileTransferEvent.prototype.actionId = 0;

        /**
         * ImgFileTransferEvent serviceId.
         * @member {string} serviceId
         * @memberof ussevent.ImgFileTransferEvent
         * @instance
         */
        ImgFileTransferEvent.prototype.serviceId = "";

        /**
         * ImgFileTransferEvent serviceIdx.
         * @member {number} serviceIdx
         * @memberof ussevent.ImgFileTransferEvent
         * @instance
         */
        ImgFileTransferEvent.prototype.serviceIdx = 0;

        /**
         * ImgFileTransferEvent imgid.
         * @member {string} imgid
         * @memberof ussevent.ImgFileTransferEvent
         * @instance
         */
        ImgFileTransferEvent.prototype.imgid = "";

        /**
         * ImgFileTransferEvent code.
         * @member {number} code
         * @memberof ussevent.ImgFileTransferEvent
         * @instance
         */
        ImgFileTransferEvent.prototype.code = 0;

        /**
         * ImgFileTransferEvent extendId.
         * @member {string} extendId
         * @memberof ussevent.ImgFileTransferEvent
         * @instance
         */
        ImgFileTransferEvent.prototype.extendId = "";

        /**
         * ImgFileTransferEvent cost.
         * @member {number} cost
         * @memberof ussevent.ImgFileTransferEvent
         * @instance
         */
        ImgFileTransferEvent.prototype.cost = 0;

        /**
         * ImgFileTransferEvent fsize.
         * @member {number} fsize
         * @memberof ussevent.ImgFileTransferEvent
         * @instance
         */
        ImgFileTransferEvent.prototype.fsize = 0;

        /**
         * ImgFileTransferEvent strategyVer.
         * @member {number} strategyVer
         * @memberof ussevent.ImgFileTransferEvent
         * @instance
         */
        ImgFileTransferEvent.prototype.strategyVer = 0;

        /**
         * Creates a new ImgFileTransferEvent instance using the specified properties.
         * @function create
         * @memberof ussevent.ImgFileTransferEvent
         * @static
         * @param {ussevent.IImgFileTransferEvent=} [properties] Properties to set
         * @returns {ussevent.ImgFileTransferEvent} ImgFileTransferEvent instance
         */
        ImgFileTransferEvent.create = function create(properties) {
            return new ImgFileTransferEvent(properties);
        };

        /**
         * Encodes the specified ImgFileTransferEvent message. Does not implicitly {@link ussevent.ImgFileTransferEvent.verify|verify} messages.
         * @function encode
         * @memberof ussevent.ImgFileTransferEvent
         * @static
         * @param {ussevent.IImgFileTransferEvent} message ImgFileTransferEvent message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ImgFileTransferEvent.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.actionId);
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.serviceId);
            writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.serviceIdx);
            writer.uint32(/* id 4, wireType 2 =*/34).string(message.imgid);
            writer.uint32(/* id 5, wireType 0 =*/40).uint32(message.code);
            if (message.extendId != null && Object.hasOwnProperty.call(message, "extendId"))
                writer.uint32(/* id 6, wireType 2 =*/50).string(message.extendId);
            if (message.cost != null && Object.hasOwnProperty.call(message, "cost"))
                writer.uint32(/* id 7, wireType 0 =*/56).uint32(message.cost);
            if (message.fsize != null && Object.hasOwnProperty.call(message, "fsize"))
                writer.uint32(/* id 8, wireType 0 =*/64).uint32(message.fsize);
            writer.uint32(/* id 9, wireType 0 =*/72).uint32(message.strategyVer);
            return writer;
        };

        /**
         * Encodes the specified ImgFileTransferEvent message, length delimited. Does not implicitly {@link ussevent.ImgFileTransferEvent.verify|verify} messages.
         * @function encodeDelimited
         * @memberof ussevent.ImgFileTransferEvent
         * @static
         * @param {ussevent.IImgFileTransferEvent} message ImgFileTransferEvent message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ImgFileTransferEvent.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an ImgFileTransferEvent message from the specified reader or buffer.
         * @function decode
         * @memberof ussevent.ImgFileTransferEvent
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {ussevent.ImgFileTransferEvent} ImgFileTransferEvent
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ImgFileTransferEvent.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.ussevent.ImgFileTransferEvent();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.actionId = reader.uint32();
                    break;
                case 2:
                    message.serviceId = reader.string();
                    break;
                case 3:
                    message.serviceIdx = reader.uint32();
                    break;
                case 4:
                    message.imgid = reader.string();
                    break;
                case 5:
                    message.code = reader.uint32();
                    break;
                case 6:
                    message.extendId = reader.string();
                    break;
                case 7:
                    message.cost = reader.uint32();
                    break;
                case 8:
                    message.fsize = reader.uint32();
                    break;
                case 9:
                    message.strategyVer = reader.uint32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            if (!message.hasOwnProperty("actionId"))
                throw $util.ProtocolError("missing required 'actionId'", { instance: message });
            if (!message.hasOwnProperty("serviceId"))
                throw $util.ProtocolError("missing required 'serviceId'", { instance: message });
            if (!message.hasOwnProperty("serviceIdx"))
                throw $util.ProtocolError("missing required 'serviceIdx'", { instance: message });
            if (!message.hasOwnProperty("imgid"))
                throw $util.ProtocolError("missing required 'imgid'", { instance: message });
            if (!message.hasOwnProperty("code"))
                throw $util.ProtocolError("missing required 'code'", { instance: message });
            if (!message.hasOwnProperty("strategyVer"))
                throw $util.ProtocolError("missing required 'strategyVer'", { instance: message });
            return message;
        };

        /**
         * Decodes an ImgFileTransferEvent message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof ussevent.ImgFileTransferEvent
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {ussevent.ImgFileTransferEvent} ImgFileTransferEvent
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ImgFileTransferEvent.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an ImgFileTransferEvent message.
         * @function verify
         * @memberof ussevent.ImgFileTransferEvent
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ImgFileTransferEvent.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (!$util.isInteger(message.actionId))
                return "actionId: integer expected";
            if (!$util.isString(message.serviceId))
                return "serviceId: string expected";
            if (!$util.isInteger(message.serviceIdx))
                return "serviceIdx: integer expected";
            if (!$util.isString(message.imgid))
                return "imgid: string expected";
            if (!$util.isInteger(message.code))
                return "code: integer expected";
            if (message.extendId != null && message.hasOwnProperty("extendId"))
                if (!$util.isString(message.extendId))
                    return "extendId: string expected";
            if (message.cost != null && message.hasOwnProperty("cost"))
                if (!$util.isInteger(message.cost))
                    return "cost: integer expected";
            if (message.fsize != null && message.hasOwnProperty("fsize"))
                if (!$util.isInteger(message.fsize))
                    return "fsize: integer expected";
            if (!$util.isInteger(message.strategyVer))
                return "strategyVer: integer expected";
            return null;
        };

        /**
         * Creates an ImgFileTransferEvent message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof ussevent.ImgFileTransferEvent
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {ussevent.ImgFileTransferEvent} ImgFileTransferEvent
         */
        ImgFileTransferEvent.fromObject = function fromObject(object) {
            if (object instanceof $root.ussevent.ImgFileTransferEvent)
                return object;
            var message = new $root.ussevent.ImgFileTransferEvent();
            if (object.actionId != null)
                message.actionId = object.actionId >>> 0;
            if (object.serviceId != null)
                message.serviceId = String(object.serviceId);
            if (object.serviceIdx != null)
                message.serviceIdx = object.serviceIdx >>> 0;
            if (object.imgid != null)
                message.imgid = String(object.imgid);
            if (object.code != null)
                message.code = object.code >>> 0;
            if (object.extendId != null)
                message.extendId = String(object.extendId);
            if (object.cost != null)
                message.cost = object.cost >>> 0;
            if (object.fsize != null)
                message.fsize = object.fsize >>> 0;
            if (object.strategyVer != null)
                message.strategyVer = object.strategyVer >>> 0;
            return message;
        };

        /**
         * Creates a plain object from an ImgFileTransferEvent message. Also converts values to other types if specified.
         * @function toObject
         * @memberof ussevent.ImgFileTransferEvent
         * @static
         * @param {ussevent.ImgFileTransferEvent} message ImgFileTransferEvent
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ImgFileTransferEvent.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.actionId = 0;
                object.serviceId = "";
                object.serviceIdx = 0;
                object.imgid = "";
                object.code = 0;
                object.extendId = "";
                object.cost = 0;
                object.fsize = 0;
                object.strategyVer = 0;
            }
            if (message.actionId != null && message.hasOwnProperty("actionId"))
                object.actionId = message.actionId;
            if (message.serviceId != null && message.hasOwnProperty("serviceId"))
                object.serviceId = message.serviceId;
            if (message.serviceIdx != null && message.hasOwnProperty("serviceIdx"))
                object.serviceIdx = message.serviceIdx;
            if (message.imgid != null && message.hasOwnProperty("imgid"))
                object.imgid = message.imgid;
            if (message.code != null && message.hasOwnProperty("code"))
                object.code = message.code;
            if (message.extendId != null && message.hasOwnProperty("extendId"))
                object.extendId = message.extendId;
            if (message.cost != null && message.hasOwnProperty("cost"))
                object.cost = message.cost;
            if (message.fsize != null && message.hasOwnProperty("fsize"))
                object.fsize = message.fsize;
            if (message.strategyVer != null && message.hasOwnProperty("strategyVer"))
                object.strategyVer = message.strategyVer;
            return object;
        };

        /**
         * Converts this ImgFileTransferEvent to JSON.
         * @function toJSON
         * @memberof ussevent.ImgFileTransferEvent
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ImgFileTransferEvent.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ImgFileTransferEvent;
    })();

    ussevent.ImgNotifyEvent = (function() {

        /**
         * Properties of an ImgNotifyEvent.
         * @memberof ussevent
         * @interface IImgNotifyEvent
         * @property {number} actionId ImgNotifyEvent actionId
         * @property {string} serviceId ImgNotifyEvent serviceId
         * @property {string} imgid ImgNotifyEvent imgid
         * @property {number} code ImgNotifyEvent code
         * @property {number} cost ImgNotifyEvent cost
         * @property {number} strategyVer ImgNotifyEvent strategyVer
         */

        /**
         * Constructs a new ImgNotifyEvent.
         * @memberof ussevent
         * @classdesc Represents an ImgNotifyEvent.
         * @implements IImgNotifyEvent
         * @constructor
         * @param {ussevent.IImgNotifyEvent=} [properties] Properties to set
         */
        function ImgNotifyEvent(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ImgNotifyEvent actionId.
         * @member {number} actionId
         * @memberof ussevent.ImgNotifyEvent
         * @instance
         */
        ImgNotifyEvent.prototype.actionId = 0;

        /**
         * ImgNotifyEvent serviceId.
         * @member {string} serviceId
         * @memberof ussevent.ImgNotifyEvent
         * @instance
         */
        ImgNotifyEvent.prototype.serviceId = "";

        /**
         * ImgNotifyEvent imgid.
         * @member {string} imgid
         * @memberof ussevent.ImgNotifyEvent
         * @instance
         */
        ImgNotifyEvent.prototype.imgid = "";

        /**
         * ImgNotifyEvent code.
         * @member {number} code
         * @memberof ussevent.ImgNotifyEvent
         * @instance
         */
        ImgNotifyEvent.prototype.code = 0;

        /**
         * ImgNotifyEvent cost.
         * @member {number} cost
         * @memberof ussevent.ImgNotifyEvent
         * @instance
         */
        ImgNotifyEvent.prototype.cost = 0;

        /**
         * ImgNotifyEvent strategyVer.
         * @member {number} strategyVer
         * @memberof ussevent.ImgNotifyEvent
         * @instance
         */
        ImgNotifyEvent.prototype.strategyVer = 0;

        /**
         * Creates a new ImgNotifyEvent instance using the specified properties.
         * @function create
         * @memberof ussevent.ImgNotifyEvent
         * @static
         * @param {ussevent.IImgNotifyEvent=} [properties] Properties to set
         * @returns {ussevent.ImgNotifyEvent} ImgNotifyEvent instance
         */
        ImgNotifyEvent.create = function create(properties) {
            return new ImgNotifyEvent(properties);
        };

        /**
         * Encodes the specified ImgNotifyEvent message. Does not implicitly {@link ussevent.ImgNotifyEvent.verify|verify} messages.
         * @function encode
         * @memberof ussevent.ImgNotifyEvent
         * @static
         * @param {ussevent.IImgNotifyEvent} message ImgNotifyEvent message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ImgNotifyEvent.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.actionId);
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.serviceId);
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.imgid);
            writer.uint32(/* id 4, wireType 0 =*/32).uint32(message.code);
            writer.uint32(/* id 5, wireType 0 =*/40).uint32(message.cost);
            writer.uint32(/* id 6, wireType 0 =*/48).uint32(message.strategyVer);
            return writer;
        };

        /**
         * Encodes the specified ImgNotifyEvent message, length delimited. Does not implicitly {@link ussevent.ImgNotifyEvent.verify|verify} messages.
         * @function encodeDelimited
         * @memberof ussevent.ImgNotifyEvent
         * @static
         * @param {ussevent.IImgNotifyEvent} message ImgNotifyEvent message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ImgNotifyEvent.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an ImgNotifyEvent message from the specified reader or buffer.
         * @function decode
         * @memberof ussevent.ImgNotifyEvent
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {ussevent.ImgNotifyEvent} ImgNotifyEvent
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ImgNotifyEvent.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.ussevent.ImgNotifyEvent();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.actionId = reader.uint32();
                    break;
                case 2:
                    message.serviceId = reader.string();
                    break;
                case 3:
                    message.imgid = reader.string();
                    break;
                case 4:
                    message.code = reader.uint32();
                    break;
                case 5:
                    message.cost = reader.uint32();
                    break;
                case 6:
                    message.strategyVer = reader.uint32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            if (!message.hasOwnProperty("actionId"))
                throw $util.ProtocolError("missing required 'actionId'", { instance: message });
            if (!message.hasOwnProperty("serviceId"))
                throw $util.ProtocolError("missing required 'serviceId'", { instance: message });
            if (!message.hasOwnProperty("imgid"))
                throw $util.ProtocolError("missing required 'imgid'", { instance: message });
            if (!message.hasOwnProperty("code"))
                throw $util.ProtocolError("missing required 'code'", { instance: message });
            if (!message.hasOwnProperty("cost"))
                throw $util.ProtocolError("missing required 'cost'", { instance: message });
            if (!message.hasOwnProperty("strategyVer"))
                throw $util.ProtocolError("missing required 'strategyVer'", { instance: message });
            return message;
        };

        /**
         * Decodes an ImgNotifyEvent message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof ussevent.ImgNotifyEvent
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {ussevent.ImgNotifyEvent} ImgNotifyEvent
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ImgNotifyEvent.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an ImgNotifyEvent message.
         * @function verify
         * @memberof ussevent.ImgNotifyEvent
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ImgNotifyEvent.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (!$util.isInteger(message.actionId))
                return "actionId: integer expected";
            if (!$util.isString(message.serviceId))
                return "serviceId: string expected";
            if (!$util.isString(message.imgid))
                return "imgid: string expected";
            if (!$util.isInteger(message.code))
                return "code: integer expected";
            if (!$util.isInteger(message.cost))
                return "cost: integer expected";
            if (!$util.isInteger(message.strategyVer))
                return "strategyVer: integer expected";
            return null;
        };

        /**
         * Creates an ImgNotifyEvent message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof ussevent.ImgNotifyEvent
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {ussevent.ImgNotifyEvent} ImgNotifyEvent
         */
        ImgNotifyEvent.fromObject = function fromObject(object) {
            if (object instanceof $root.ussevent.ImgNotifyEvent)
                return object;
            var message = new $root.ussevent.ImgNotifyEvent();
            if (object.actionId != null)
                message.actionId = object.actionId >>> 0;
            if (object.serviceId != null)
                message.serviceId = String(object.serviceId);
            if (object.imgid != null)
                message.imgid = String(object.imgid);
            if (object.code != null)
                message.code = object.code >>> 0;
            if (object.cost != null)
                message.cost = object.cost >>> 0;
            if (object.strategyVer != null)
                message.strategyVer = object.strategyVer >>> 0;
            return message;
        };

        /**
         * Creates a plain object from an ImgNotifyEvent message. Also converts values to other types if specified.
         * @function toObject
         * @memberof ussevent.ImgNotifyEvent
         * @static
         * @param {ussevent.ImgNotifyEvent} message ImgNotifyEvent
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ImgNotifyEvent.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.actionId = 0;
                object.serviceId = "";
                object.imgid = "";
                object.code = 0;
                object.cost = 0;
                object.strategyVer = 0;
            }
            if (message.actionId != null && message.hasOwnProperty("actionId"))
                object.actionId = message.actionId;
            if (message.serviceId != null && message.hasOwnProperty("serviceId"))
                object.serviceId = message.serviceId;
            if (message.imgid != null && message.hasOwnProperty("imgid"))
                object.imgid = message.imgid;
            if (message.code != null && message.hasOwnProperty("code"))
                object.code = message.code;
            if (message.cost != null && message.hasOwnProperty("cost"))
                object.cost = message.cost;
            if (message.strategyVer != null && message.hasOwnProperty("strategyVer"))
                object.strategyVer = message.strategyVer;
            return object;
        };

        /**
         * Converts this ImgNotifyEvent to JSON.
         * @function toJSON
         * @memberof ussevent.ImgNotifyEvent
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ImgNotifyEvent.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ImgNotifyEvent;
    })();

    ussevent.GetEndpointStrategyEvent = (function() {

        /**
         * Properties of a GetEndpointStrategyEvent.
         * @memberof ussevent
         * @interface IGetEndpointStrategyEvent
         * @property {number} actionId GetEndpointStrategyEvent actionId
         * @property {number|null} [ver] GetEndpointStrategyEvent ver
         * @property {number|null} [cost] GetEndpointStrategyEvent cost
         */

        /**
         * Constructs a new GetEndpointStrategyEvent.
         * @memberof ussevent
         * @classdesc Represents a GetEndpointStrategyEvent.
         * @implements IGetEndpointStrategyEvent
         * @constructor
         * @param {ussevent.IGetEndpointStrategyEvent=} [properties] Properties to set
         */
        function GetEndpointStrategyEvent(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GetEndpointStrategyEvent actionId.
         * @member {number} actionId
         * @memberof ussevent.GetEndpointStrategyEvent
         * @instance
         */
        GetEndpointStrategyEvent.prototype.actionId = 0;

        /**
         * GetEndpointStrategyEvent ver.
         * @member {number} ver
         * @memberof ussevent.GetEndpointStrategyEvent
         * @instance
         */
        GetEndpointStrategyEvent.prototype.ver = 0;

        /**
         * GetEndpointStrategyEvent cost.
         * @member {number} cost
         * @memberof ussevent.GetEndpointStrategyEvent
         * @instance
         */
        GetEndpointStrategyEvent.prototype.cost = 0;

        /**
         * Creates a new GetEndpointStrategyEvent instance using the specified properties.
         * @function create
         * @memberof ussevent.GetEndpointStrategyEvent
         * @static
         * @param {ussevent.IGetEndpointStrategyEvent=} [properties] Properties to set
         * @returns {ussevent.GetEndpointStrategyEvent} GetEndpointStrategyEvent instance
         */
        GetEndpointStrategyEvent.create = function create(properties) {
            return new GetEndpointStrategyEvent(properties);
        };

        /**
         * Encodes the specified GetEndpointStrategyEvent message. Does not implicitly {@link ussevent.GetEndpointStrategyEvent.verify|verify} messages.
         * @function encode
         * @memberof ussevent.GetEndpointStrategyEvent
         * @static
         * @param {ussevent.IGetEndpointStrategyEvent} message GetEndpointStrategyEvent message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetEndpointStrategyEvent.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.actionId);
            if (message.ver != null && Object.hasOwnProperty.call(message, "ver"))
                writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.ver);
            if (message.cost != null && Object.hasOwnProperty.call(message, "cost"))
                writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.cost);
            return writer;
        };

        /**
         * Encodes the specified GetEndpointStrategyEvent message, length delimited. Does not implicitly {@link ussevent.GetEndpointStrategyEvent.verify|verify} messages.
         * @function encodeDelimited
         * @memberof ussevent.GetEndpointStrategyEvent
         * @static
         * @param {ussevent.IGetEndpointStrategyEvent} message GetEndpointStrategyEvent message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetEndpointStrategyEvent.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a GetEndpointStrategyEvent message from the specified reader or buffer.
         * @function decode
         * @memberof ussevent.GetEndpointStrategyEvent
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {ussevent.GetEndpointStrategyEvent} GetEndpointStrategyEvent
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetEndpointStrategyEvent.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.ussevent.GetEndpointStrategyEvent();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.actionId = reader.uint32();
                    break;
                case 2:
                    message.ver = reader.uint32();
                    break;
                case 3:
                    message.cost = reader.uint32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            if (!message.hasOwnProperty("actionId"))
                throw $util.ProtocolError("missing required 'actionId'", { instance: message });
            return message;
        };

        /**
         * Decodes a GetEndpointStrategyEvent message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof ussevent.GetEndpointStrategyEvent
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {ussevent.GetEndpointStrategyEvent} GetEndpointStrategyEvent
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetEndpointStrategyEvent.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a GetEndpointStrategyEvent message.
         * @function verify
         * @memberof ussevent.GetEndpointStrategyEvent
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        GetEndpointStrategyEvent.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (!$util.isInteger(message.actionId))
                return "actionId: integer expected";
            if (message.ver != null && message.hasOwnProperty("ver"))
                if (!$util.isInteger(message.ver))
                    return "ver: integer expected";
            if (message.cost != null && message.hasOwnProperty("cost"))
                if (!$util.isInteger(message.cost))
                    return "cost: integer expected";
            return null;
        };

        /**
         * Creates a GetEndpointStrategyEvent message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof ussevent.GetEndpointStrategyEvent
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {ussevent.GetEndpointStrategyEvent} GetEndpointStrategyEvent
         */
        GetEndpointStrategyEvent.fromObject = function fromObject(object) {
            if (object instanceof $root.ussevent.GetEndpointStrategyEvent)
                return object;
            var message = new $root.ussevent.GetEndpointStrategyEvent();
            if (object.actionId != null)
                message.actionId = object.actionId >>> 0;
            if (object.ver != null)
                message.ver = object.ver >>> 0;
            if (object.cost != null)
                message.cost = object.cost >>> 0;
            return message;
        };

        /**
         * Creates a plain object from a GetEndpointStrategyEvent message. Also converts values to other types if specified.
         * @function toObject
         * @memberof ussevent.GetEndpointStrategyEvent
         * @static
         * @param {ussevent.GetEndpointStrategyEvent} message GetEndpointStrategyEvent
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GetEndpointStrategyEvent.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.actionId = 0;
                object.ver = 0;
                object.cost = 0;
            }
            if (message.actionId != null && message.hasOwnProperty("actionId"))
                object.actionId = message.actionId;
            if (message.ver != null && message.hasOwnProperty("ver"))
                object.ver = message.ver;
            if (message.cost != null && message.hasOwnProperty("cost"))
                object.cost = message.cost;
            return object;
        };

        /**
         * Converts this GetEndpointStrategyEvent to JSON.
         * @function toJSON
         * @memberof ussevent.GetEndpointStrategyEvent
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GetEndpointStrategyEvent.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return GetEndpointStrategyEvent;
    })();

    return ussevent;
})();

module.exports = $root;
